import TablePage from "@beeldit/core/pages/TablePage";
import config from "../config";
import DetailsPage from "@beeldit/core/pages/DetailsPage";
import { DetailsActionProvider } from "@beeldit/core/actions/details/DetailsActionContext";

function ConfigurationPage() {

  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
  }

  return (
          <DetailsActionProvider>
            <DetailsPage
              {...tablePageParams}
            />
          </DetailsActionProvider>
  );
}

export default ConfigurationPage;
